import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4e6bbec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audio-style-panel" }
const _hoisted_2 = { class: "row tr_row" }
const _hoisted_3 = { style: {"flex":"2"} }
const _hoisted_4 = { class: "row switch-row tr_row" }
const _hoisted_5 = { style: {"flex":"2"} }
const _hoisted_6 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_7 = { class: "row switch-row tr_row" }
const _hoisted_8 = { style: {"flex":"2"} }
const _hoisted_9 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}

import { Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTAudioElement } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from '../common/ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import { Popover, Switch } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'AudioStylePanel',
  setup(__props) {

const { t, locale } = useI18n()

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const handleAudioElement = handleElement as Ref<PPTAudioElement>

const { addHistorySnapshot } = useHistorySnapshot()

const updateAudio = (props: Partial<PPTAudioElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.audioStylePanel.imgColor`)) + "：", 1),
      _createVNode(_unref(Popover), { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(handleAudioElement).color,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = value => updateAudio({ color: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(handleAudioElement).color,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.audioStylePanel.autoPlay`)) + "：", 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Switch), {
          checked: _unref(handleAudioElement).autoplay,
          onChange: _cache[1] || (_cache[1] = checked => updateAudio({ autoplay: checked as boolean }))
        }, null, 8, ["checked"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.audioStylePanel.loopPlay`)) + "：", 1),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Switch), {
          checked: _unref(handleAudioElement).loop,
          onChange: _cache[2] || (_cache[2] = checked => updateAudio({ loop: checked as boolean }))
        }, null, 8, ["checked"])
      ])
    ])
  ]))
}
}

})